import React from 'react';

const ChannelTwitter = (props) => (
  <svg
    viewBox="0 0 14 14"
    height="1em"
    {...props}
  >
    <g
      transform="translate(0, 1.5)"
      fill="#1da1f2"
    >
      <path d="M13.5931 1.30994C13.0941 1.5293 12.5612 1.67873 12.0001 1.74696C12.5719 1.40242 13.0117 0.859384 13.2198 0.211463C12.6835 0.524427 12.0892 0.752243 11.4565 0.87912C10.9512 0.33834 10.2311 0 9.43153 0C7.89941 0 6.65714 1.24227 6.65714 2.7727C6.65714 2.99262 6.68252 3.20408 6.72876 3.40652C4.4224 3.29769 2.37827 2.19019 1.01025 0.515969C0.76946 0.923104 0.634688 1.39622 0.634688 1.91162C0.634688 2.87589 1.12528 3.72343 1.8685 4.22136C1.41343 4.2067 0.985434 4.08151 0.612132 3.87399V3.90839C0.612132 5.25329 1.56681 6.37489 2.83728 6.63034C2.60439 6.69293 2.35853 6.72676 2.10647 6.72676C1.9294 6.72676 1.75967 6.70985 1.58993 6.67827C1.94576 7.77957 2.96867 8.58256 4.18613 8.60512C3.23878 9.3489 2.03824 9.79213 0.745212 9.79213C0.525291 9.79213 0.305934 9.77916 0.0854492 9.75434C1.31983 10.5404 2.77413 11 4.34684 11C9.45239 11 12.2409 6.773 12.2409 3.11329C12.2409 2.99544 12.2409 2.87645 12.2324 2.75804C12.7743 2.36951 13.2474 1.87835 13.6196 1.32122L13.5931 1.30994Z" />
    </g>
  </svg>
);

export default ChannelTwitter;
